module.exports = __webpack_public_path__ + "static/media/posts-tiny.457b128f.svg";